import type { Chain } from '../../../chain';
import { CHAINS_INFO_MAP } from '../../constants';

/**
 * Maps the chain name from the API to the SDK chain name
 */
export const getSdkChainFromApiChainName = (
  chainName: string
): Chain | null => {
  const chains = Object.keys(CHAINS_INFO_MAP) as Chain[];

  const chain = chains.find(
    (chain) => CHAINS_INFO_MAP[chain].apiChainName === chainName
  );

  return chain || null;
};
